import { render, staticRenderFns } from "./BuildingList.vue?vue&type=template&id=4882da21&scoped=true&"
import script from "./BuildingList.vue?vue&type=script&lang=js&"
export * from "./BuildingList.vue?vue&type=script&lang=js&"
import style0 from "./BuildingList.vue?vue&type=style&index=0&id=4882da21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882da21",
  null
  
)

export default component.exports